export const STORE_LINKS = {
  chrome: 'https://chrome.google.com/webstore/detail/highvocab-vocabulary-buil/nmalijlbcckplnamalenpdaafacfeemd?hl=en',
  edge: 'https://microsoftedge.microsoft.com/addons/detail/highvocab-vocabulary-bui/dfpolnmicooilcndegandafkmooecmei',
  firefox: 'https://addons.mozilla.org/en-US/firefox/addon/highvocab-vocabulary-builder/',
  ios: 'https://apps.apple.com/us/app/highvocab/id6770623659',
  android: 'https://play.google.com/store/apps/details?id=com.highvocab.app',
};

// Device-based (not viewport-based): a narrow desktop window should still get
// the extension-first page. iPadOS reports itself as a Mac, so check touch too.
export const getPlatform = () => {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  if (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
  return 'desktop';
};

export const isMobilePlatform = (platform = getPlatform()) => platform !== 'desktop';
